
import React from 'react';
import { 
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { usePaymentCredentials } from '../hooks/usePaymentCredentials';
import { Loader } from 'lucide-react';

interface PayPalConfigDialogProps {
  shopId: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSaved?: () => void;
}

export const PayPalConfigDialog: React.FC<PayPalConfigDialogProps> = ({
  shopId,
  open,
  onOpenChange,
  onSaved
}) => {
  const {
    apiKey, 
    setApiKey,
    apiSecret, 
    setApiSecret,
    isSaving,
    isLoading,
    handleSaveCredentials
  } = usePaymentCredentials(shopId, 'paypal');

  const handleSave = async () => {
    const success = await handleSaveCredentials();
    if (success) {
      if (onSaved) onSaved();
      onOpenChange(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Configuration PayPal</DialogTitle>
        </DialogHeader>
        
        {isLoading ? (
          <div className="flex justify-center items-center py-8">
            <Loader className="h-6 w-6 animate-spin text-primary" />
            <span className="ml-2">Chargement des identifiants...</span>
          </div>
        ) : (
          <div className="space-y-4 py-4">
            <div className="space-y-2">
              <Label htmlFor="paypal-api-key">Client ID</Label>
              <Input
                id="paypal-api-key"
                type="text"
                value={apiKey}
                onChange={(e) => setApiKey(e.target.value)}
                placeholder="AZDsj4p1spXm_o8..."
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="paypal-api-secret">Secret</Label>
              <Input
                id="paypal-api-secret"
                type="password"
                value={apiSecret}
                onChange={(e) => setApiSecret(e.target.value)}
                placeholder="EAWr6-KZx_xhJf7..."
              />
              <p className="text-xs text-muted-foreground">Cette clé sera chiffrée avant d'être stockée.</p>
            </div>
          </div>
        )}
        
        <DialogFooter>
          <Button
            onClick={handleSave}
            disabled={isLoading || isSaving || (!apiKey || !apiSecret)}
          >
            {isSaving ? 'Enregistrement...' : 'Enregistrer les identifiants'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
